import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-participant-profile',
  standalone: true,
  imports: [RouterLink, TranslateModule],
  templateUrl: './participant-profile.component.html',
  styleUrls: ['./participant.scss']
})
export class ParticipantProfileComponent {

}
